import { useQuery } from "@tanstack/react-query";
import { hubPacketArchive } from "@/lib/api";

export default function PacketArchive() {
  const { data = [], isLoading } = useQuery({ queryKey: ["hub-packet"], queryFn: hubPacketArchive });
  return (
    <div data-testid="hub-packet-archive">
      <p className="cv-kicker">Operating Room</p>
      <h1 className="cv-display text-3xl mt-4">The archive.</h1>
      <p className="cv-body text-[#1F1B16]/70 mt-4 max-w-xl">One specific insight from the work, monthly. No pitch.</p>
      {isLoading ? (
        <p className="cv-body text-[#9A938A] mt-8">Loading...</p>
      ) : (
        <div className="mt-8 divide-y divide-[rgba(28,27,25,0.14)] border-t border-[rgba(28,27,25,0.14)]">
          {data.map((p) => (
            <article key={p.slug} data-testid="hub-packet-item" className="py-7">
              <h2 className="cv-h2 text-base">{p.title}</h2>
              <p className="cv-body text-sm text-[#1F1B16]/70 mt-2">{p.excerpt}</p>
              {p.body && (
                <div className="mt-4 space-y-3">
                  {p.body.map((para, i) => (
                    <p key={i} className="cv-body text-sm text-[#1F1B16]/85">{para}</p>
                  ))}
                </div>
              )}
            </article>
          ))}
          {data.length === 0 && <p className="cv-body text-sm text-[#9A938A] py-6">The first issue lands soon.</p>}
        </div>
      )}
    </div>
  );
}
